import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../../barcodeform.css';
import Select from 'react-select';
import jQuery from 'jquery';
import ReportIssueButton from './ReportIssueButton';
export default function ChangeStatus() {

    const API_URL = process.env.REACT_APP_API_URL;
    const [barcode, setBarcode] = useState('');
    const [shipmentDetails, setShipmentDetails] = useState([]);
    const [loading, setLoading] = useState(false);

    const $ = jQuery.noConflict();


    const [modalClosed, setModalClosed] = useState(false);

useEffect(() => {
    if (modalClosed) {
        getDetails();
        setModalClosed(false); // reset
    }
}, [modalClosed]);

useEffect(() => {
    const handleModalClose = () => setModalClosed(true);
    window.addEventListener("modalClosed", handleModalClose);

    return () => {
        window.removeEventListener("modalClosed", handleModalClose);
    };
}, []);

    useEffect(() => {



        $(".btn-demo.import").on('click', function () {
            $('.nalier.middle-center.fade').css("display", "block");
            $('.nalier.middle-center.fade').addClass("in");
        });

        $(".close.h-close").on('click', function () {
            $('.nalier.middle-center.fade.in').css("display", "none");
            $('.nalier.middle-center.fade').removeClass("in");
            window.dispatchEvent(new Event("modalClosed")); 
        });

        $(".close.h-close2").on('click', function () {
            $('.nalier.middle-center2.fade.in').css("display", "none");
            $('.nalier.middle-center2.fade').removeClass("in");
        });

    }, []);

    const buttonsyle = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginRight: '10px',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%'
    }
    const buttonsyle1 = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        // marginLeft: '75%',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%',
        marginBottom: '10%'
    }


    const [msg, setMsg] = useState('')
    const [errormsg, setError] = useState('')

    useEffect(() => {
        // Fetch drivers from the API on component mount
        fetchDrivers();
        getUserList();

    }, []);

    const [scaninfo, setScaninfo] = useState({
        driver: '',
         failureReason:'',
    image:''
    })

    const [weightdata, setWeightData] = useState({
        weight: '',
        length: '',
        width: '',
        height: ''
    })

    const [drivers, setDrivers] = useState()
    const [awb, setAwb] = useState();
    const fetchDrivers = async () => {
        try {
            // Replace this API endpoint with the actual one that fetches drivers based on the emirate
            const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

            if (response.data.success) {
                const driversData = response.data.data;  // The array of driver objects

                // Map the response to extract driverId and name
                const driversList = driversData.map(driver => ({
                    driver_id: driver.driverId,
                    driver_name: driver.name
                }));

                // Set the drivers state
                setDrivers(driversList);
            } else {
                console.error('Error fetching drivers for emirate:');
            }
        } catch (error) {
            console.error('Error fetching drivers:', error);
        }
    };

    const [users, setusers] = useState()
    const getUserList = async () => {
        const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

        // Send a GET request to the new API
        try {
            const res = await axios.get(API_PATH);

            console.log(res.data);  // Log the response to inspect it

            // Check if the response contains 'data' and if it's an array
            if (res.data && res.data.success && Array.isArray(res.data.data)) {
                setusers(res.data.data);  // Update the personnel list in the state
            } else {
                console.log('No personnel data found in the response or response is not successful');
            }



        } catch (err) {
            console.log('Error fetching personnel list:', err);

        }
    };

    console.log('drivers:', drivers)
    console.log('scan:', scaninfo)
    console.log('users:', users)
const [awbchosen, setawbchosen] = useState()
function  getDetails(){ console.log('awb is',awb)
        
        const scannedBarcode = awb
        .split(/[\n,]+/)
        .filter((value) => value.trim() !== '')
        .map((value) => {
            if (value.startsWith('E') && value.charAt(value.length - 5) === 'D') {
                return value.slice(3, -5);
            }
            return value;
        })[0]; // Get the first element from the array
    
        if (!scannedBarcode) {
            scannedBarcode = awb;
          }



        const payload = {

            awbNo: scannedBarcode
        };

        console.log(payload)
        setError('')
        axios.post(`${API_URL}shypvdriverapp/jobs/getJobDetails`, payload)
            .then(response => {
                console.log("Response:", response.data);
                if (response.data.success) {
                    if (response.data.data.length > 0) {
                        setShipmentDetails(response.data.data)
                    } else {
                        setShipmentDetails(response.data.data)

                        setError('booking details not found')
                    }

                } else {

                    setShipmentDetails([])
                    setError('booking details not found')
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }


    const [errorNew, seterrorNew] = useState('')
    const AddStatus = async () => {
        setScaninfo({
            driver: '',
            failureReason: '',
            image: '',
            scan_date:'',
            scan_time:'',
            status:''
          });

        seterrorNew('')
       setMsg('')
        $('.nalier.middle-center.fade').css("display", "block");
        $('.nalier.middle-center.fade').addClass("in");
    };
  


    
    function addNewStatus() {
      if (scaninfo.driver && scaninfo.scan_date && scaninfo.scan_time && scaninfo.status)  {
    
        if(scaninfo.status=="DELIVERED"){
          if(! scaninfo.image){
            setMsg('Image is required');
            return;
          }
        }
        if(scaninfo.status=="FAILED"){
          if(! scaninfo.failureReason){
            setMsg('Please choose a reason ');
            return;
          }
        }
        setError('');
        setMsg('');
    
        // Create a new FormData object
        const formData = new FormData();
        formData.append('scan_date', scaninfo.scan_date);
        formData.append('scan_time', scaninfo.scan_time);
        formData.append('driver_id', scaninfo.driver);
        formData.append('status', scaninfo.status);
        formData.append('updated_by', sessionStorage.getItem('userid'));
        formData.append('failed_reason', scaninfo.failureReason);
        formData.append('comments', scaninfo.comments);
    formData.append('awbs[]', awb);
    
        // formData.append('awbs', JSON.stringify(shipmentDetails));
        formData.append('POD_image', scaninfo.image);
       
    
        // For debugging, log the formData content (Note: formData doesn't log like regular objects, so we need to inspect its entries)
        console.log('FormData entries:' ,formData);
        for (let pair of formData.entries()) {
          console.log(pair[0] + ': ' + pair[1]);
        }
    
        setMsg('Processing...');
    
        // Make the POST request with the FormData
        axios.post(`${API_URL}shypvdriverapp/jobs/updateMultipleAwbs`, formData)
          .then(response => {
            console.log("Response:", response.data);
    
            // Initialize success flag
            let allSuccess = true;
            let errorMessages = [];
    
            // Loop through each AWB in the response data
            response.data.data.forEach(item => {
              const awb = item.awb;
              const status = item.orderDetails[0]?.status;
    
              // Accumulate error messages for failures
              errorMessages.push(`${awb}: ${status}.`);
              allSuccess = false;
            });
    
            // If all updates are successful, show success message
            if (allSuccess) {
              setMsg('Status Updated');
            } else {
              setMsg(errorMessages.join('\n'));
              // setError(errorMessages.join(' '));  // You can uncomment this line if you want to set an error as well
            }
          })
          .catch(error => {
            console.error("Error:", error);
            setMsg('Something went wrong. Please try again.');
            setError('Something went wrong. Please try again.');
          });
      } else {
        setError('Please enter all the required fields');
      }
    }

  


    function saveWeight() {
        if (weightdata.weight != "") {
            setError('')
            setMsg('')
            const payload = {
                awb: awb,
                weight: weightdata.weight,
                length: weightdata.length,
                width: weightdata.width,
                height: weightdata.height,
                image: weightdata.image,
                updated_by: sessionStorage.getItem('userid')
            };

            console.log(payload)

           
        }
    }



     const [driverNames, setDriverNames] = useState({});

const fetchedDriverIds = useRef(new Set());
const fetchingDriverIds = useRef(new Set());

useEffect(() => {
  const uniqueDriverIds = [
    ...new Set(
      shipmentDetails
        .map(s => s.driverId)
        .filter(id => id) // ignore null
    )
  ];

  const idsToFetch = uniqueDriverIds.filter(id =>
    !fetchedDriverIds.current.has(id) &&
    !fetchingDriverIds.current.has(id)
  );

  if (idsToFetch.length === 0) return;

  const fetchDrivers = async () => {
    const updatedNames = { ...driverNames };

    await Promise.all(
      idsToFetch.map(async (id) => {
        // Mark as currently fetching → prevents parallel duplicate calls
        fetchingDriverIds.current.add(id);

        try {
          const res = await axios.get(`${API_URL}shypvdriverapp/driver/getDriver`, {
            params: { driverId: id }
          });

          updatedNames[id] = res.data?.data?.name || "No driver found";

        } catch (err) {
          console.error("Driver API error", err);
          updatedNames[id] = "Error fetching driver";

        } finally {
          // Move from fetching → fetched
          fetchingDriverIds.current.delete(id);
          fetchedDriverIds.current.add(id);
        }
      })
    );

    setDriverNames(updatedNames);
  };

  fetchDrivers();
}, [JSON.stringify(shipmentDetails.map(s => s.driverId))]); 



   const getDriverName = (driverId, driverNames) => {
  // Synchronously return the driver name from the state (after it's been fetched)
  return driverNames[driverId] || 'Loading...'; // Default to 'Loading...' until the name is fetched
};
    const getUserName = (userid) => {
        console.log('user is ', userid)
        const user = users.find(user => user.personnel_id === parseInt(userid));

        return user ? user.personnel_name : 'Unknown'; // Default to 'Unknown' if not found
    };



    const [allStatus, setallStatus] = useState()
    useEffect(() => {
        // Make the API call when the component mounts
        axios
            .get(`${API_URL}shypvdriverapp/jobs/getAllStatus`)
            .then((response) => {
                setallStatus(response.data.data);  // Store the data in state
                setLoading(false);        // Set loading to false when done
            })
            .catch((err) => {
                setError(err);            // Store the error in state if something goes wrong
                setLoading(false);        // Set loading to false even if there's an error
            });
    }, []);


    
      
    const [allExceptions, setallExceptions] = useState()
    useEffect(() => {
        // Make the API call when the component mounts
        axios
          .get(`${API_URL}shypvdriverapp/jobs/getAllExceptionStatus`)
          .then((response) => {
            setallExceptions(response.data.data);  // Store the data in state
            setLoading(false);        // Set loading to false when done
          })
          .catch((err) => {
            setError(err);            // Store the error in state if something goes wrong
            setLoading(false);        // Set loading to false even if there's an error
          });
      }, []); 

    console.log('all', allStatus)

    //   const [updatedDetails, setUpdatedDetails] = useState(shipmentDetails);
    const [newStatus, setnewStatus] = useState(0)
    // Handle status change
    const handleStatusChange = (index, newStatus) => {
        setnewStatus(newStatus)
        // Create a copy of the current shipment details
        const updatedShipmentDetails = [...shipmentDetails];

        // Update the status at the specified index
        updatedShipmentDetails[index].status = newStatus;

        // Update the state with the new shipment details array
        setShipmentDetails(updatedShipmentDetails);
    };


    function editStatus(orderid) {

        console.log('ship', shipmentDetails)
        console.log('new', newStatus)
        const filteredShipment = shipmentDetails.filter(shipment => shipment.order_id === orderid);
   if((newStatus.toLowerCase()=='delivered' || newStatus.toLowerCase()=='failed' ) && sessionStorage.getItem('role') != 'super_admin'){
    alert('You cannot update an existing status to failed or delivered unless you are a super admin. Please use add status option or bulk scan page')
    return;
   }
        // Log the filtered result to the console
        console.log('Filtered shipment:', filteredShipment);
        if (newStatus.length > 1) {
            //call API
            const shipment = filteredShipment[0]; // Assuming there's only one shipment with that order_id
            const { awb, scanDate, status, driverId } = shipment;

            // Prepare the payload for the API request
            const apiPayload = {
                awb: awb,
                date: new Date(scanDate).toISOString().split('T')[0], // Extract just the date part in YYYY-MM-DD format
                time: new Date(scanDate).toISOString().split('T')[1].slice(0, 8), // Extract just the time part (HH:MM:SS)
                status: newStatus,  // Change this according to your need or input
                driverId: driverId, // Default to 4 if driverId is not available in the shipment
                orderId: orderid,
                updated_by: sessionStorage.getItem('userid')
            };
            console.log(apiPayload)
            axios.post(`${API_URL}shypvdriverapp/jobs/editJobStatus`, apiPayload, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    // Handle the response from the API
                    if (response.data.success) {
                        console.log('API call successful:', response.data);
                        alert('Job status updated successfully!');
                    } else {
                        console.error('API call failed:', response.data.errors);
                        alert('Failed to update job status.');
                    }
                })
                .catch(error => {
                    // Handle any error that occurred during the API call
                    console.error('Error making API call:', error);
                    alert('Error occurred while updating the job status.');
                });
        }
    }


    function deleteStatus(orderId) {
        // Show a confirmation dialog before proceeding with the delete action
        const isConfirmed = window.confirm('Are you sure you want to delete this job status?');

        // If the user confirms, proceed with the API call
        if (isConfirmed) {
            const apiPayload = {
                awb: awb,
                orderId: orderId
            };

            axios.post(`${API_URL}shypvdriverapp/jobs/deleteJobStatus`, apiPayload, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    // Handle the API response
                    if (response.data.success) {
                        console.log('Job status deleted successfully:', response.data);
                        alert('Job status deleted successfully!');
                        getDetails();  // Assuming getDetails fetches the latest shipment details
                    } else {
                        console.error('Failed to delete job status:', response.data.errors);
                        alert('Failed to delete job status.');
                    }
                })
                .catch(error => {
                    // Handle any error that occurred during the API call
                    console.error('Error making API call:', error);
                    alert('Error occurred while deleting the job status.');
                });
        } else {
            // If user cancels, log that the delete was canceled
            console.log('Delete action was canceled by the user.');
        }
    };

    console.log('shipmentDetails', shipmentDetails)

    
    const [searchQuery, setSearchQuery] = useState("");
    
       const filteredDrivers = Array.isArray(drivers) 
            ? drivers.filter(driver =>
                driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
            )
            : [];
    
            const driverOptions = filteredDrivers.map(driver => ({
            value: driver.driver_id,
            label: `${driver.driver_id} - ${driver.driver_name}`
        }));
    
         const handleChange = (selectedOption) => {
            setScaninfo({ ...scaninfo, driver: selectedOption.value });
        };
    
    return (
        <div>
            <ReportIssueButton pageContext="UPDATE_STATUS" pageLabel="Update Status" awb={barcode} />
            <div className="form-container">

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="driver">AWB: </label>
                            <input
                                type="text"
                                value={awb}
                                onChange={e => setAwb(e.target.value)}
                                placeholder="Enter AWB"
                                autoFocus
                            />
                        </div>
                        {/* Date Input */}

                        {/* Time Input */}

                        {/* Driver Selection */}


                        {/* Barcode Input */}

                        <a onClick={getDetails} style={buttonsyle} type="button" className="btn-demo add">
                            Submit
                        </a>
                        <p style={{ color: 'red', marginTop: '2%' }}>{errormsg}</p>
                    </div>




                </div>
                <div className="row">
                    <div className="col-md-10">
                        {loading && <p>Loading shipment details...</p>}

                        {shipmentDetails.length > 0 && (
                            <div>

                                <h3>Shipment Details:</h3>
                                <div className='row'>

                                  
                                    <div className="col-md-3" style={{ width: 'auto', float: 'right' }}>
                                        <a onClick={AddStatus} style={buttonsyle1} type="button" className="btn-demo add">
                                            Add Status
                                        </a>
                                    </div>

                                </div>
                                <div className="shipdata" style={{
                                    background: '#5583af59',
                                    maxHeight: '500px', // Adjust the height limit as needed
                                    overflowY: 'auto',  // Enables vertical scrolling
                                    padding: '10px',   // Optional: Add some padding for better visuals
                                    border: '1px solid #ccc',// Optional: Add a border for separation
                                    marginBottom: '3%',
                                    minWidth: '1000px'
                                }}>
                                    <table className='table  table-bordered table-striped'>
                                        <thead>
                                            <tr>
                                                <th>Status</th>
                                                <th>Date</th>
                                                <th>Homebase</th>
                                                <th>Driver</th>
                                                <th>Updated By</th>
                                                <th>Updated On</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {shipmentDetails.map((data, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <select
                                                            value={data.status}
                                                              disabled={data.status.toLowerCase() === 'delivered' && sessionStorage.getItem('role') !== 'super_admin'}
                                                            onChange={(e) => handleStatusChange(index, e.target.value)} // Handle status change
                                                        >
                                                            {allStatus && allStatus
    .filter(status => !(allExceptions || []).includes(status)).map((status, i) => (
                                                                <option key={i} value={status}>
                                                                    {status}
                                                                </option>
                                                            ))}

                                                            {allStatus && !allStatus.includes(data.status) && (
                                                                <option value={data.status}>
                                                                    {data.status}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <p>{data.subStatus !== null && data.subStatus !== undefined ? data.subStatus : ''}</p>

                                                    </td>
                                                    <td>{data.scanDate && data.scanDate !=''? data.scanDate:data.updatedDate} </td>
                                                   <td>{data.homeBase}</td>
                                                    {data.driverId ? (
     <td>{getDriverName(data.driverId, driverNames)}</td> // Call the function if driverId is valid
  ) : (
    'Unknown' // Show this if driverId is not valid
  )}
                                                    <td>{data.updatedBy}</td>
                                                    <td>{data.updatedDate}</td>

                                                    <td><a className="editBtn" onClick={() => editStatus(data.order_id)}>update <i className='fa fa-edit ' ></i>  </a>
                                                        {sessionStorage.getItem('role') && sessionStorage.getItem('role') == 'super_admin' ? (
                                                            <a className="deleteBtn" onClick={() => deleteStatus(data.order_id)}> <i className='fa fa-trash'></i></a>
                                                        ) : ('')}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                </div>

                                {shipmentDetails[0]?.masterAwbNumber && (
                                    <div className="mawb-panel" style={{
                                        background: '#f8fafc',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        marginBottom: '3%'
                                    }}>
                                        <div style={{ marginBottom: '8px', fontSize: '13px', color: '#374151' }}>
                                            <i className="fa fa-sitemap" style={{ marginRight: '6px' }} />
                                            Master AWB: <strong style={{ fontFamily: 'monospace' }}>{shipmentDetails[0].masterAwbNumber}</strong>
                                            {' '}&mdash; this order is a multi-shipment (MAWB) grouping. Each child AWB below has its own independent status.
                                        </div>
                                        {shipmentDetails[0].childAwbs && shipmentDetails[0].childAwbs.length > 0 ? (
                                            <table className='table table-bordered table-striped' style={{ fontSize: '13px' }}>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Child AWB</th>
                                                        <th>Title</th>
                                                        <th>Piece Ref</th>
                                                        <th>Description</th>
                                                        <th>Weight</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {shipmentDetails[0].childAwbs.map((c, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td style={{ fontFamily: 'monospace' }}>{c.childAwb || '-'}</td>
                                                            <td>{c.title || '-'}</td>
                                                            <td>{c.pieceReference || '-'}</td>
                                                            <td>{c.description || '-'}</td>
                                                            <td>{c.weight != null ? c.weight : '-'}</td>
                                                            <td>{c.status || '-'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div style={{ fontSize: '12px', color: '#6b7280' }}>No child AWBs found.</div>
                                        )}
                                    </div>
                                )}

                            </div>


                        )}

                    </div>
                </div>
            </div>

            <div className="nalier middle-center fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" style={{ display: "none" }}>
                <div className="nalier-dialog" style={{ height: 'auto' }} role="document">
                    <div className="nalier-content">

                        <div className="nalier-header">
                            <button type="button" className="close h-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="nalier-title" id="myModalLabel"> {awb}</h4>
                        </div>
                        <div className="nalier-body">
                            <div className="modal-gap">&nbsp;</div>


                            <div className="row" style={{ textAlign: "center", padding: "15px", margin: "15px" }} >
                                <div className="form-container">

                                    <div className="row">
                                        <div className="col-md-6">

                                            {/* Date Input */}
                                            <div className="form-group">
                                                <label htmlFor="date">Date:</label>
                                                <input
                                                    type="date"
                                                    id="date"
                                                    onChange={(e) => setScaninfo({ ...scaninfo, scan_date: e.target.value })}
                                                    value={scaninfo.scan_date}

                                                />
                                            </div>
                                            {/* Driver Selection */}

                                            <div className="form-group">
                                                        <label htmlFor="driver">Select Driver:</label>
                                                        <Select
                                                            options={driverOptions}
                                                            value={driverOptions.find(option => option.value === scaninfo.driver)}
                                                            onChange={handleChange}
                                                            placeholder="Select a driver"
                                                            onInputChange={newValue => setSearchQuery(newValue)} // Update search query
                                                            isSearchable
                                                            noOptionsMessage={() => "No drivers found"}
                                                        />
                                                    </div>
                                            {/* <div className="form-group">
                                                <label htmlFor="driver">Select Driver:</label>
                                                <select
                                                    id="driver"
                                                    value={scaninfo.driver}
                                                    onChange={(e) => setScaninfo({ ...scaninfo, driver: e.target.value })}

                                                >
                                                    <option value="">Select a driver</option>
                                                    {drivers && drivers.map((driver) => (
                                                        <option key={driver.driver_id} value={driver.driver_id}>
                                                            {driver.driver_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div> */}

                                               
                                                <div className="form-group">
                                                <label htmlFor="driver">Comments:</label>
                                                
                                                <textarea
    id="driver-comments"
    value={scaninfo.comments}
    onChange={(e) => setScaninfo({ ...scaninfo, comments: e.target.value })}
    placeholder="Enter comments..."
    rows={4}
    style={{ width: '100%' }} // Optional: for full-width textarea
/>

                                            </div>
                                        

                                        </div>
                                        <div className="col-md-6">
                                            {/* Time Input */}
                                            <div className="form-group">
                                                <label htmlFor="time">Time:</label>
                                                <input
                                                    type="time"
                                                    id="time"
                                                    onChange={(e) => setScaninfo({ ...scaninfo, scan_time: e.target.value })}
                                                    value={scaninfo.scan_time}

                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="driver">Select Status:</label>
                                                <select
                                                    id="driver"
                                                    value={scaninfo.status}
                                                    onChange={(e) => setScaninfo({ ...scaninfo, status: e.target.value })}

                                                >
                                                    <option value="">Select a status</option>
                                                    {allStatus && allStatus
    .filter(status => !(allExceptions || []).includes(status)).map((status, i) => (
                                                        <option key={i} value={status}>
                                                            {status}
                                                        </option>
                                                    ))}




                                                </select>
                                            </div>


                                            {scaninfo.status === 'DELIVERED' && (
                <div className="form-group">
                    <label htmlFor="imageUpload">Upload Image:</label>
                    <input
                        type="file"
                        id="imageUpload"
                        onChange={(e) => setScaninfo({ ...scaninfo, image: e.target.files[0] })}
                    />
                </div>
            )}

            {/* Conditional render for "Failed" status */}
            {scaninfo.status === 'FAILED' && (
                <div className="form-group">
                    <label htmlFor="failureReason">Select Failure Reason:</label>
                    <select
                        id="failureReason"
                        value={scaninfo.failureReason}
                        onChange={(e) => setScaninfo({ ...scaninfo, failureReason: e.target.value })}
                    >
                        <option value="">Select a reason</option>
                        {allExceptions && allExceptions.map((reason, i) => (
                            <option key={i} value={reason}>
                                {reason}
                            </option>
                        ))}
                    </select>
                </div>
            )}

         
                                            <p style={{color:'red'}}>{msg}</p>

                                        </div>
                                        
                                         
                                       
                                        <a onClick={addNewStatus} style={buttonsyle} type="button" className="btn-demo add">
                                            Submit
                                        </a>
                                        <p style={{ color: 'red', marginTop: '2%' }}>{errorNew}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-5">

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <div className="nalier middle-center2 fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" style={{ display: "none" }}>
                <div className="nalier-dialog" style={{ height: 'auto' }} role="document">
                    <div className="nalier-content">

                        <div className="nalier-header">
                            <button type="button" className="close h-close2" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h4 className="nalier-title" id="myModalLabel"> {awb}</h4>
                        </div>
                        <div className="nalier-body">
                            <div className="modal-gap">&nbsp;</div>


                            <div className="row" style={{ textAlign: "center", padding: "15px", margin: "15px" }} >
                                <div className="form-container">

                                    <div className="row">
                                        <div className="col-md-3">

                                            {/* Date Input */}
                                            <div className="form-group">
                                                <label htmlFor="date">Weight:</label>
                                                <input
                                                    type="text"
                                                    id="weight"
                                                    onChange={(e) => setWeightData({ ...weightdata, weight: e.target.value })}
                                                    value={weightdata.weight}

                                                />
                                            </div>
                                        </div>
                                        {/* Driver Selection */}
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="driver">Length</label>
                                                <input
                                                    type="text"
                                                    id="length"
                                                    onChange={(e) => setWeightData({ ...weightdata, length: e.target.value })}
                                                    value={weightdata.length}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="driver">Width</label>
                                                <input
                                                    type="text"
                                                    id="width"
                                                    onChange={(e) => setWeightData({ ...weightdata, width: e.target.value })}
                                                    value={weightdata.width}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="driver">Height</label>
                                                <input
                                                    type="text"
                                                    id="height"
                                                    onChange={(e) => setWeightData({ ...weightdata, height: e.target.value })}
                                                    value={weightdata.height}

                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            {/* Time Input */}
                                            <div className="form-group">
                                                <label htmlFor="time">Image:</label>
                                                <input
                                                    type="file"
                                                    id="image"
                                                    onChange={(e) => setWeightData({ ...weightdata, image: e.target.files[0] })}


                                                />
                                            </div>


                                            <p>{msg}</p>

                                        </div>
                                        <a onClick={saveWeight} style={{ ...buttonsyle, marginTop: '6%' }} type="button" className="btn-demo add">
                                            Submit
                                        </a>

                                        <p style={{ color: 'red', marginTop: '2%' }}>{errorNew}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-5">

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

